import { environment } from "../utils/environment";
import { Sku } from "../types/Sku";

const baseFetch = <T> (endpoint: string) => {
    return new Promise<T>((resolve, reject) => {
        fetch(environment.mongo_api_base_url + endpoint)
          .then((resp) => resp.json())
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
}
 
export const getVipStakingLevels = () => {
  return baseFetch<any>("/configs/vipbenefits");
};

export const getSkuList = () => {
    return baseFetch<Sku[]>("/skulist");
}

export const getServerTime = async () => {
    const serverTimestamp = await baseFetch<number>("/configs/time");
    return serverTimestamp || null;
}
